import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface GiftAFriendCSSStyle extends UIComponentCSSStyle
{
    getContactNumberCSSStyle(): object;
    getConfirmButtonCSSStyle(): object;
    getContentDivCSSStyle():object;
    getContentLabel1CSSStyle():object;
    getContentLabel2CSSStyle():object;
    getTermsConditionCSSStyle(): object;
    getRowDivCSSStyle(): object ;

}

export class GiftAFriendCSSStyleImpl extends UIComponentCSSStyleImpl implements GiftAFriendCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            paddingBottom:'30px',
            backgroundColor: this.getResources().getColor(Colors.color_5),
        };
    }

    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "50px",
            display: "flex",
            width:'100%',
            justifyContent:'center',
            position: "relative",
            alignItems:'center',
            flexDirection:"row",
            flexFlow: "row wrap",
        };
    }
    getContactNumberCSSStyle(): object 
    {
        return {
            width: "100%",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingTop: "5px",
            paddingLeft: "32px",
            paddingRight: "32px",
        };
    }
    getContentDivCSSStyle(): object 
    {
        return{
            width:'227px',
            margin:'0px 106.5px 10px 106.5px',
            height:'20px',
            textAlign:'center' 
        };
    }

    getTermsConditionCSSStyle(): object {
        return{
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:'#231F20',
            fontWeight:'500',
            fontFamily:this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            // flex: 2,
            // paddingTop:'5px',
            // marginLeft:'5px',
        };
    }
    getContentLabel1CSSStyle(): object 
    {
        return{
            color:this.getResources().getColor(Colors.color_19),
            fontSize:this.getResources().getFont(Fonts.h8),
            textAlign:'center',
            lineHeight:'10px'
        };
    }

    getContentLabel2CSSStyle(): object 
    {
        return{
            color:this.getResources().getColor(Colors.color_21), 
            fontSize:this.getResources().getFont(Fonts.h9),
            textAlign:'center',
            fontWeight:500,
            lineHeight:'20px'
        };
    }
    getConfirmButtonCSSStyle(): object 
    {
        return {
            marginTop: "25px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto"
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/giftafriend/giftafriendcss.tsx